import React from "react"

import ApplicationLogin from "@/components/application/ApplicationLogin"
import AppLayout from "@/components/layout/AppLayout"

const LoginPage = () => {
  return (
    <AppLayout showJobPosting={false}>
      <div className="container mx-auto flex min-h-[60vh] items-center justify-center px-4 md:px-8">
        <div className="w-full max-w-md">
          <div className="mb-8 text-center">
            <h1 className="mb-2 text-2xl font-bold text-jungle">Access Your Application</h1>
            <p className="text-gray-600">Enter your details to continue your application process</p>
          </div>
          <ApplicationLogin />
        </div>
      </div>
    </AppLayout>
  )
}

export default LoginPage
